export default __webpack_public_path__ + "static/media/oracle.13093bb6.png";